var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./PerspectiveArticlesList.jinja');
require('./PerspectiveArticlesList.less');

var PerspectiveArticlesListInner = require('front/components/PerspectiveArticlesList/PerspectiveArticlesListInner');
var PerspectiveArticlesListInnerTemplate = require('front/components/PerspectiveArticlesList/PerspectiveArticlesListInner.jinja');

var objectFitImages = require('object-fit-images');

require('dotdotdot');

module.exports = Base.extend({

    template: template,

    events: {
        'click .PerspectiveArticlesList-btnMore': 'onClickMoreButton'
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'PerspectiveArticlesListInner': {selector: '.PerspectiveArticlesListInner', viewConstructor: PerspectiveArticlesListInner},
    },

    moreApi: function () {
        return this.state.next;
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'moreApi', 'updateEllipsis');

        this.state = {
            next: Urls['front:api:perspective-article']() + '?offset=' + this.$('.PerspectiveArticlesListInner-article').size(),
            hasMore: false
        };

        Base.prototype.initialize.call(this, options);

        this.$('.PerspectiveArticlesListInner-articleDetails p').dotdotdot({
            watch: true
        });

        window.app.vent.on('fonts-loaded', this.updateEllipsis);
    },


    updateEllipsis: function () {
        this.$('.PerspectiveArticlesListInner-articleDetails p').trigger('update.dot');
    },


    onClickMoreButton: function () {
        var self = this;
        this.$('.PerspectiveArticlesList-btnMore').addClass('Button--loading');

        this.forceLoadData(this.moreApi)
            .then(function () {
                self.state.next = self.data.next;
                var $articles = $(PerspectiveArticlesListInnerTemplate.render({data: {list: self.data.results}}));


                self.$('.PerspectiveArticlesList-btnMore')
                    .toggle(!!self.state.hasMore)
                    .removeClass('Button--loading');

                self.$('.PerspectiveArticlesList-articles').append($articles);

                app.animateShowMoreSlideDown({$items: $articles});

                $(window).resize();

                new PerspectiveArticlesListInner({
                    el: $articles[0]
                });

                $articles.find('.PerspectiveArticlesListInner-articleDetails p').dotdotdot({
                    watch: true
                });

                window.app.utils.updateLinksAttributes(self.$('.PerspectiveArticlesList-articles'));

                objectFitImages();
            });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/PerspectiveArticlesList/PerspectiveArticlesList.js
// module id = 234
// module chunks = 0